import React from 'react'

// הודעת תוצאה אחרי מימוש הטבה (הצלחה או שגיאה), באותו סגנון של חלון האישור
const BenefitResultPopup = ({ show, success = true, title, message, onClose }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4" dir='rtl'>
      <div className="bg-white rounded-xl shadow-lg w-full max-w-md relative animate-fadeIn p-6">

        {/* סגירה */}
        <button
          type="button"
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
          aria-label="סגור"
        >
          ✕
        </button>

        {/* אייקון הצלחה / שגיאה */}
        <div className={`mx-auto mb-3 w-16 h-16 rounded-full flex items-center justify-center text-3xl text-white ${success ? 'bg-[#28a745]' : 'bg-[#dc3545]'}`}>
          {success ? '✔' : '✕'}
        </div>

        {/* כותרת */}
        <h2 className={`text-xl font-bold text-center mb-3 ${success ? 'text-[#0d406b]' : 'text-[#dc3545]'}`}>
          {title}
        </h2>

        {/* ההודעה שחזרה מהשרת */}
        <p className="text-gray-700 text-sm text-center leading-relaxed mb-5 whitespace-pre-line">
          {message}
        </p>

        <button
          type="button"
          onClick={onClose}
          className="w-full bg-[#0d406b] text-white py-2 rounded-lg font-semibold hover:bg-[#0b3558] transition shadow"
        >
          סגור
        </button>

      </div>
    </div>
  );
}

export default BenefitResultPopup
